import { Box } from "@chakra-ui/react"
import { DepositForAccount } from "@mezo/api"

import StbtcDepositsCarousel from "../StbtcDepositsCarousel"

import StbtcManageInfo from "./StbtcManageInfo"
import StbtcManageModalHeader from "./StbtcManageModalHeader"
import StbtcReturnForm from "./StbtcReturnForm"

type StbtcManageModalBaseProps = {
  deposits: DepositForAccount[]
  /**
   * Total minted stbtc amount. In token (user) unit.
   */
  totalMintedTokenAmount: bigint
  selectedDeposit?: DepositForAccount
  onDepositCarouselChange: (previousIndex: number, nextIndex: number) => void
}

export default function StbtcManageModalBase({
  deposits,
  totalMintedTokenAmount,
  selectedDeposit,
  onDepositCarouselChange,
}: StbtcManageModalBaseProps) {
  return (
    <Box bg="primary.white.100" borderRadius="1.5rem" w="522px">
      <StbtcManageModalHeader
        totalStbtcTokensToReturn={totalMintedTokenAmount}
      />
      <StbtcDepositsCarousel
        variant="manage"
        mainLabelText="Choose minted deposit"
        deposits={deposits}
        onItemChange={onDepositCarouselChange}
        mt="40px"
        mb="8px"
      />
      <Box px="55px" pb="32px">
        <StbtcReturnForm deposit={selectedDeposit} />
        <StbtcManageInfo mt="32px" />
      </Box>
    </Box>
  )
}
